export default "__VITE_ASSET__qxtss6qQ__"